export default {
  'noMessagesDesc': 'To start messaging somebody go to their profile and click the Contact button.'
}



// WEBPACK FOOTER //
// ./src/i18n/es/messages.js